var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#fccc0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.032 29.342v12.891h11.36c2.258 0 3.95-.26 5.079-.781 1.996-.912 2.995-2.713 2.995-5.404 0-2.908-.966-4.86-2.898-5.86-1.085-.563-2.712-.846-4.883-.846H36.032Zm21.5-7.096A12.129 12.129 0 0 1 62.14 25.6a14.855 14.855 0 0 1 2.474 4.036c.607 1.476.911 3.158.911 5.046 0 2.279-.575 4.52-1.725 6.722-1.15 2.203-3.05 3.76-5.697 4.671 2.214.89 3.782 2.154 4.704 3.793.922 1.638 1.383 4.14 1.383 7.503v3.222c0 2.192.087 3.679.26 4.46.261 1.237.869 2.148 1.824 2.734v1.205H55.238a34.431 34.431 0 0 1-.651-2.572 23.63 23.63 0 0 1-.424-4.134l-.065-4.46c-.043-3.06-.602-5.1-1.676-6.12-1.074-1.02-3.087-1.53-6.038-1.53H36.031v18.816h-9.798V21.009h23.535c3.364.065 5.952.477 7.764 1.237Z",
    style: {
      fill: "#000",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.38fd0607cb24357b0ce7650128cbf31f.svg";
export { ForwardRef as ReactComponent };